<script setup>
import SideFilter from '../SideFilter.vue'

import useWeekDateFilter from '@/utils/useWeekDateFilter'
import { DATE_END_STR, DATE_START_STR } from '@/constants/general'
import { useStore } from '@/utils/VuexHelpers'
import { computed, ref } from 'vue'

const revenueSideFilter = ref(null)

const store = useStore()
const filtersRevenue = computed(() => store.getters.filtersRevenue)

const { updateDateFilter } = useWeekDateFilter(
  'filtersRevenue',
  'SET_FILTER_REVENUE'
)

const isDateFilter = (field) => {
  return [DATE_START_STR, DATE_END_STR].includes(field)
}

const normaliseFilterValue = ({ field, value }) => {
  if (field === 'delivery_by' && value) {
    return value.name
  }

  return value
}

const updateFilter = (payload) => {
  const { field } = payload
  const value = normaliseFilterValue(payload)

  if (isDateFilter(field)) {
    updateDateFilter({ value, field })
  } else {
    store.commit('SET_FILTER_REVENUE', { value, field })
  }

  store.dispatch('fetchRevenue')
}

const updateWeekFilter = (dateRange) => {
  const { weekNr, startDay, endDay, year } = dateRange

  store.commit('SET_FILTER_REVENUE', { field: 'week', value: weekNr })
  store.commit('SET_FILTER_REVENUE', {
    field: 'date_start',
    value: startDay
  })
  store.commit('SET_FILTER_REVENUE', {
    field: 'date_end',
    value: endDay
  })

  if (filtersRevenue.value.year.value !== year) {
    store.commit('SET_FILTER_REVENUE', { field: 'year', value: year })
  }

  store.dispatch('fetchRevenue')
}

const updateYearFilter = (data) => {
  const { year } = data
  const cleanYear = parseInt(year.trim())

  if (cleanYear === filtersRevenue.value.year.value) return

  store.commit('SET_FILTER_REVENUE', {
    field: 'year',
    value: cleanYear
  })

  if (!filtersRevenue.value.week.value) return

  revenueSideFilter.value.generateWeekDays(
    filtersRevenue.value.week.value,
    cleanYear
  )
}

const resetFilters = () => {
  store.dispatch('clearFiltersRevenue')
  store.dispatch('fetchRevenue')
}
</script>

<template>
  <SideFilter
    ref="revenueSideFilter"
    class="mt-0"
    :filter-list="filtersRevenue"
    @input="updateFilter"
    @inputWeek="updateWeekFilter"
    @inputYear="updateYearFilter"
    @clear="resetFilters"
  />
</template>
